/* eslint-disable object-curly-newline */

import getDefaultState from './get-default-state';

export default {
  setBlogs(state, blogs) {
    state.blogs = blogs;
  },

  setBlog(state, blog) {
    state.blog = blog;
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },

  setFilters(state, { types, themes }) {
    // const modifiedAuthors = map(authors, u => extend({
    //   value: `${u.firstName} ${u.lastName}`,
    //   code: `${u.id}`,
    // }, u));

    state.filters = { types, themes };
  },
};
